import { useState } from 'react';
import { TableInput } from '../../../../../components/common';

interface IProps {
  moduleData: any;
  isView: boolean;
}
const TfootSetup = ({ isView, moduleData }: IProps) => {
  const [render, setRender] = useState(false);
  return (
    <tfoot>
       <tr>
        <th colSpan={14} rowSpan={2}>
          NOTE:- TO BE MENTION FOR APPROVAL AT THE TIME OF EACH SET UP. ALL
          <br></br>
          DIMENSION ARE IN MM WHERE IT IS CHANGED HAS BEEN MENTIONED.
        </th>
        <th colSpan={7} rowSpan={2}>
          VERIFIED BY (SIGN):- {moduleData?.report_approved_by}
        </th>
      </tr>
    </tfoot>
  );
};

export default TfootSetup;
